import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import BootstrapVue from 'bootstrap-vue'
import VueAnalytics from 'vue-analytics'
import VueSignaturePad from 'vue-signature-pad'
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './registerServiceWorker'

// https://medium.com/@rooshan/sentry-with-vue-js-820f7199a742
Sentry.init({
  dsn: 'https://6be6ab732e0e4a27b43147a926a931e8@o256713.ingest.sentry.io/2244221',
  integrations: [
    new Integrations.Vue({
      Vue,
      attachProps: true,
    }),
  ],
});

Vue.config.productionTip = false;
Vue.use(BootstrapVue);
Vue.use(VueSignaturePad);
Vue.use(VueAnalytics, {
  id: 'UA-137529-5',
  router
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
